import { toast } from "react-toastify";
import FetchRUC from "../externalAPIs/FetchRuc";

export const RucVerifier = async ({
  ruc,
  rucSetter,
  setter,
  nameBrand,
  address,
  setIsRucLoading,
}) => {
  if (!ruc || ruc.length !== 11) {
    toast.warning("RUC inválido - debe tener 11 dígitos");
    return;
  }

  const result = await FetchRUC({
    ruc,
    loadingSetter: setIsRucLoading,
  });

  if (!result || !result.brandName) {
    toast.error("RUC no encontrado");
    return;
  }

  setter((prev) => ({
    ...prev,
    [nameBrand]: result.brandName,
    ...(address ? { [address]: result.direccion } : {}),
  }));
  rucSetter(true);
  toast.success("RUC validado exitosamente");
};
